export const initChat = async (accessToken: string) => {
  const chatOrigin = 'https://learningmanager.adobe.com';
  const chatLive = 'https://cpcontents.adobe.com';

  const BUTTON_STYLE = {
    background: '#000000',
    borderColor: '#e5c89c',
    borderRadius: '8px',
    textColor: '#ffffff',
    fontSize: '14px',
    fontWeight: '600',
    padding: '12px 16px',
    gap: '8px',
    iconSize: 18,
    offset: '24px',
    hoverBackground: '#1b1813'
  };

  const ASK_AI_ICON = `
    <svg viewBox="0 0 24 24" width="${BUTTON_STYLE.iconSize}" height="${BUTTON_STYLE.iconSize}"
         fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"
         aria-hidden="true" focusable="false">
      <path d="M13.4 2.4 H20.6 A1.5 1.5 0 0 1 22.1 3.9 V8.3 A1.5 1.5 0 0 1 20.6 9.8 H17 L13.9 12.6 V9.8 H13.4 A1.5 1.5 0 0 1 11.9 8.3 V3.9 A1.5 1.5 0 0 1 13.4 2.4 Z"></path>
      <path d="M8.9 12.7 V11.4 A1 1 0 0 1 9.9 10.4 A1 1 0 0 1 10.9 11.4 V12.7"></path>
      <rect x="4.9" y="12.7" width="12.6" height="7.3" rx="1.7"></rect>
      <rect x="7.7" y="15.2" width="7" height="2.4" rx="1.2"></rect>
      <rect x="2.2" y="14.9" width="2.7" height="3" rx="1"></rect>
      <rect x="17.5" y="14.9" width="2.7" height="3" rx="1"></rect>
    </svg>`;

  const floatingButton = document.createElement('button');
  floatingButton.type = 'button';
  floatingButton.setAttribute('aria-expanded', 'false');
  floatingButton.innerHTML = `${ASK_AI_ICON}<span>Ask AI</span>`;
  floatingButton.style.cssText = `
      display: flex;
      position: fixed;
      bottom: ${BUTTON_STYLE.offset};
      right: ${BUTTON_STYLE.offset};
      gap: ${BUTTON_STYLE.gap};
      padding: ${BUTTON_STYLE.padding};
      border-radius: ${BUTTON_STYLE.borderRadius};
      background-color: ${BUTTON_STYLE.background};
      color: ${BUTTON_STYLE.textColor};
      border: 1px solid ${BUTTON_STYLE.borderColor};
      cursor: pointer;
      z-index: 9998;
      font-family: inherit;
      font-size: ${BUTTON_STYLE.fontSize};
      font-weight: ${BUTTON_STYLE.fontWeight};
      line-height: 1;
      white-space: nowrap;
      align-items: center;
      justify-content: center;
      transition: background-color 0.2s;
    `;
  floatingButton.addEventListener('mouseenter', () => {
    floatingButton.style.backgroundColor = BUTTON_STYLE.hoverBackground;
  });
  floatingButton.addEventListener('mouseleave', () => {
    floatingButton.style.backgroundColor = BUTTON_STYLE.background;
  });

  let iframe: HTMLIFrameElement | null = null;

  const popup = document.createElement('div');
  popup.id = 'learning-assistant-popup';
  popup.style.cssText = `
    position: fixed;
    display: none;
    bottom: 80px;
    right: 24px;
    width: 30vh;
    height: 50vh;
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    z-index: 9997;
    overflow: hidden;
  `;

  iframe = document.createElement('iframe');
  iframe.src = `${chatOrigin}/app/learning-assistant`;
  iframe.style.cssText = `
    width: 100%;
    height: 100%;
    border: none;
    overflow: hidden;
  `;

  popup.appendChild(iframe);
  document.body.appendChild(popup);

  floatingButton.addEventListener('click', () => {
    const popup = document.getElementById('learning-assistant-popup');

    if (popup && iframe) {
      popup.style.display = popup.style.display === 'none' ? 'block' : 'none';
      floatingButton.setAttribute('aria-expanded', String(popup.style.display === 'block'));

      if (popup.style.display === 'block') {
        iframe.contentWindow?.postMessage(
          {
            type: 'ALM_CHAT_OPEN'
          },
          chatLive
        );
      } else {
        iframe.contentWindow?.postMessage(
          {
            type: 'ALM_CHAT_CLOSE'
          },
          chatLive
        );
      }
    }
  });

  document.body.appendChild(floatingButton);

  const onMsgReceived = (event: MessageEvent) => {
    if (event.origin !== 'https://cpcontents.adobe.com') return;

    if (event.data && event.data.type === 'ALM_CHAT_REQUEST_CONFIG' && iframe) {
      iframe.contentWindow?.postMessage(
        {
          type: 'ALM_CHAT_CONFIG',
          payload: {
            hostName: 'learningmanager.adobe.com',
            accessToken,
            openByDefault: false,
            isAdmin: false
          }
        },
        chatLive
      );
    } else if (event.data && event.data.type === 'ALM_CHAT_CLOSED') {
      const popup = document.getElementById('learning-assistant-popup');
      if (popup) {
        popup.style.display = 'none';
        floatingButton.setAttribute('aria-expanded', 'false');
      }
    } else if (event.data && event.data.type === 'ALM_CHAT_LO_REDIRECT') {
      window.dispatchEvent(new CustomEvent('ALM_CHAT_LO_REDIRECT', { detail: event.data }));
    }
  };
  window.addEventListener('message', onMsgReceived);
};
